// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"bb56fc76","531":"0cef5997","667":"223c3955","690":"bd02d294","787":"bd46f37b","820":"8d693a10","877":"60488db4"}[chunkId] + ".chunk.js";
};